import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';

export interface KrecargasConfig {
  appId: string;
  programId: string;
  factor: number;
  offset_cents: number;
}

interface KrecargasApiResponse {
  status: string;
  data: KrecargasConfig;
}

@Injectable({
  providedIn: 'root',
})
export class KrecargasService {
  private baseUrl = environment.krecargas_api.base_url;

  constructor(private http: HttpClient) {}

  getConfig(programId: string): Observable<KrecargasConfig> {
    return this.http.get<KrecargasApiResponse>(
      `${this.baseUrl}/admin/programConfig`,
      { params: { programId } }
    ).pipe(map((res) => res.data));
  }

  createConfig(config: KrecargasConfig): Observable<KrecargasConfig> {
    return this.http.post<KrecargasApiResponse>(
      `${this.baseUrl}/admin/programConfig`,
      config
    ).pipe(map((res) => res.data));
  }

  updateConfig(config: KrecargasConfig): Observable<KrecargasConfig> {
    return this.http.patch<KrecargasApiResponse>(
      `${this.baseUrl}/admin/programConfig`,
      config
    ).pipe(map((res) => res.data));
  }

  /**
   * Intenta crear la config; si el backend responde 409 (ya existe),
   * reintenta con PATCH. Evita depender de si el front sabe de antemano
   * si la config ya existe.
   */
  upsertConfig(config: KrecargasConfig): Observable<KrecargasConfig> {
    return this.createConfig(config).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.status === 409) {
          return this.updateConfig(config);
        }
        return throwError(() => err);
      })
    );
  }
}
